import * as React from 'react';
import * as I18n from 'i18n-js';
import gql from 'graphql-tag';
import { graphql, ChildMutateProps } from 'react-apollo';
import { RemoveFeedEntry, reverb_feed_FeedEntry } from '../schemas/rql';

interface IExternalProps {
  entry: Partial<reverb_feed_FeedEntry>;
}

type IProps = ChildMutateProps<IExternalProps, RemoveFeedEntry.Mutation, RemoveFeedEntry.Variables>;

export function HideFeedItem(props: IProps) {
  function removeItem() {
    props.mutate({
      variables: {
        input: {
          entryId: String(props.entry.id),
          entryType: props.entry.type,
        },
      },
    });
  }

  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        removeItem();
      }}
      title={I18n.t('discovery.feed.remove')}
      data-tooltip-align="right"
      data-tooltip-text={I18n.t('discovery.feed.removeTooltip')}
    />
  );
}

export default graphql<IExternalProps, RemoveFeedEntry.Mutation, RemoveFeedEntry.Variables>(
  gql`
    mutation RemoveFeedEntry($input: Input_reverb_feed_RemoveEntryRequest) {
      removeFeedEntry(input: $input) {
        entry {
          id
          type
          deleted
        }
      }
    }
  `,
)(HideFeedItem);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/feed/hide_feed_item.tsx